<template>
  <el-container class="bg">
    <el-header class="header">
		<img src="../assets/logoImgb.png" class="logoI">
		<div style="float: right;width: 230px; margin-top: 12px; ">
      <el-select v-model="language">
        <el-option v-for="item in languageList" :key="item.value" :label="item.label" :value="item.value"></el-option>
      </el-select>
			
		</div>
    </el-header>
    <el-main class="main">
      <div class="mainDiv">
        <p class="queryPlaceholder">{{$t('message.queryPlaceholder1')}}，{{$t('message.queryPlaceholder2')}}</p>
        <!-- <p class="queryPlaceholder"></p> -->
        <div class="queryBox">
          <el-input class="queryInput" v-model="orderNo"></el-input>
          <el-button type="primary" class="add_btn" @click="queryOrder">{{$t('message.queryBtnText')}}</el-button>
        </div>
        <div class="orderDetailsBox" v-if="orderList.length !== 0">
          <p class="orderDetailsTitle">{{$t('message.orderDetails')}}</p>
          <div class="orderDetails" v-for="order in orderList" :key="order.main.id">
            <p class="orderDetail">
              <!-- <span style="text-align: left;">{{$t('message.mainOrderNum')}}：{{order.main.mblno}}</span> -->
              <span style="text-align: left;">{{$t('message.querySuborderTitle')}}：{{order.main.hblno}}</span>
              <span style="text-align: left;">{{$t('message.numInOrder')}}：{{order.main.sl}}</span>
              <span style="text-align: left;">{{$t('message.deliveryAddress')}}：{{order.main.deliveryadd}}</span>
            </p>
            <el-table id="orderList" :data="order.lst" style="width: 100%" size="small" header-cell-class-name="tableHeader" cell-class-name="tableBodyer" height="100%" border>
              <el-table-column :label="$t('message.goodsDescription')" prop="hwqk" min-width="120"></el-table-column>
              <el-table-column :label="$t('message.deliverySituation')" prop="deliverySituation" min-width="120"></el-table-column>
              <el-table-column :label="$t('message.logisticsDate') + 'ID'" prop="taketime" min-width="120"></el-table-column>
            </el-table>
          </div>
        </div>
      </div>
    </el-main>
  </el-container>
</template>

<script>
  import { queryOrder } from '@/api/getData.js'
  export default {
    name: 'orderNoQuery',
    data () {
      return {
        languageList: [{ label: '日本語', value: 'ja' }, { label: '中文', value: 'zh' }, { label: 'English', value: 'en'} ],
        language: 'ja',
        orderNo: '',
        orderList: []
      }
    },
    watch: {
      language: function (newVal, oldVal) {
        this.$store.commit('setLang', newVal)
      }
    },
    created() {
      this.$store.commit('setLang', this.language)
      if (this.$route.query.order) {
        this.orderNo = this.$route.query.order
        this.queryOrder()
      }
    },
    methods: {
      async queryOrder () {
        if (!this.orderNo) {
          return
        } else {
          const loading = this.$loading({
            lock: true,
            text: 'Loading',
            spinner: 'el-icon-loading',
            background: 'rgba(0, 0, 0, 0.3)'
          })
          let param = { ORDERNUM: this.orderNo }
          let res = await queryOrder(param)
          loading.close()
          if (res.status !== 200) {
            this.$message.error('network error：' + res.status)
          } else {
            this.orderList = res.data.map(item => {
              item.lst = item.lst.map(order => {
                order.taketime = order.taketime.replace(/T/g, ' ')
                if (order.shqk === '已提货') {
                  order.deliverySituation = this.$t('message.deliverySituation1')
                } else if (order.shqk === '配送中') {
                  order.deliverySituation = this.$t('message.deliverySituation2')
                } else if (order.shqk === '已派送') {
                  order.deliverySituation = this.$t('message.deliverySituation3')
                } else {
                  order.deliverySituation = order.shqk
                }
                return order
              })
              return item
            })
          }
        }
      }
    }
  }
</script>

<style scoped>
.bg {
  background: #EEF0F5;
}
/* 布局顶部 */
.header {
  background: #333333;
  align-items: center;
  border-bottom: 1px solid #7E272F;
  padding-right: 100px;
}
.logoI{
	margin-top: 12px;
	height: 35px;
	float: left;
	display: flex;
	margin-left: 100px;
}
.main {
  padding: 0 15%;
}
.mainDiv {
  width: 100%;
  height: 100%;
  background: #FFFFFF;
  padding: 20px 0 0 0;
  overflow-y: scroll;
}
/* .mainDiv::-webkit-scrollbar { width: 0 !important; }
.mainDiv{ -ms-overflow-style: none; }
.mainDiv { overflow: -moz-scrollbars-none; } */
.queryPlaceholder {
  font-size: 20px;
  color: #333333;
  font-weight: bold;
  line-height: 30px;
}
.queryBox {
  margin-top: 20px;
  width: 100%;
  padding: 0 10%;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}
/deep/ .el-input__inner {
  text-align: left !important;
}
.queryInput {
  margin-bottom: 20px;
}
.orderDetailsBox {
  width: 100%;
  margin-top: 40px;
}
.orderDetailsTitle {
  padding: 0 10%;
  font-size: 25px;
  text-align: left;
  margin-bottom: 20px;
}
.orderDetails {
  width: 100%;
  padding: 0 10%;
  margin-bottom: 20px;
  border-top: 1px solid #E4E4E4;
}
.orderDetail {
  width: 100%;
  padding: 20px 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  font-size: 20px;
  color: #000000;
  /* line-height: 80px; */
}
.orderDetail span {
  line-height: 40px;
}
</style>
